import cx from 'clsx';
import React from 'react';

import { ReactComponent as AngelConnectorIcon } from '@assets/svg/sensors-temperature/angle_connector.svg';
import { ReactComponent as D105EquipmentIcon } from '@assets/svg/sensors-temperature/equipment_D105.svg';
import { ReactComponent as D106EquipmentIcon } from '@assets/svg/sensors-temperature/equipment_D106.svg';
import { ReactComponent as IndicatorIcon } from '@assets/svg/sensors-temperature/indicator.svg';
import { ReactComponent as SmallAngelConnectorIcon } from '@assets/svg/sensors-temperature/small_angle_connector.svg';
import { ReactComponent as StraightConnectorIcon } from '@assets/svg/sensors-temperature/straight_connector.svg';
import { ReactComponent as UnitIcon } from '@assets/svg/sensors-temperature/unit.svg';

import style from './style.module.scss';

interface IProps {
  userMetric: string;
}

const FourthRow: React.FC<IProps> = ({ userMetric }) => {
  return (
    <div className={style.row}>
      <div className={style.cell}>
        <AngelConnectorIcon className={style.leftAngelConnectorIcon} />
        <div className={style.bathTempContainer}>
          <div className={style.bathText}>
            <span>MF2 Bath Temp</span> <span>MF2 Roof Temp</span> <span>MF2 Bath Differential</span>
          </div>
          <div className={style.bathIcon}>
            <span>MF2</span>
            <UnitIcon />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon className={style.straightConnectorIcon} />
        {/* placeholder container */}
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.hidden)}>
          <div className={style.equipmentIconContainer}>
            <D105EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        {/* placeholder container */}
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.hidden)}>
          <div className={style.equipmentIconContainer}>
            <D105EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon className={style.straightConnectorIcon} />
        {/* placeholder container */}
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.hidden)}>
          <div className={style.equipmentIconContainer}>
            <D105EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        <div
          className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.stretchItem)}
        >
          <span className={style.name}>D-105</span>
          <div className={style.equipmentIconContainer}>
            <D105EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon className={style.straightConnectorIcon} />
        <div
          className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.stretchItem)}
        >
          <span className={style.name}>D-106</span>
          <div className={style.equipmentIconContainer}>
            <D106EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        {/* placeholder container */}
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.hidden)}>
          <span className={style.name}>D-106</span>
          <div className={cx(style.equipmentIconContainer)}>
            <D106EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon className={style.straightConnectorIcon} />
        {/* placeholder container */}
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.hidden)}>
          <div className={style.equipmentIconContainer}>
            <D105EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        {/* placeholder container */}
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.hidden)}>
          <div className={style.equipmentIconContainer}>
            <D105EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon className={style.straightConnectorIcon} />
        <div className={style.additionalInfoContainer}>
          <span>Die Cast Holding Furnaces</span>
          <span>Die Cast HF Mnt.</span>
          <span>Line Status</span>
          <span>Line Counts</span>
          <span>Bay 2 Mainline CV Status</span>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon className={style.straightConnectorIcon} />
        <div className={style.additionalInfoContainer}>
          <span>HF Zone Lower Temp.</span>
          <span>Structural HF Temperature</span>
          <span>HF Lower Tem 2</span>
        </div>
      </div>
      <div className={style.cell}>
        <SmallAngelConnectorIcon className={style.smallAngelConnectorIcon} />
        <div className={cx(style.bathTempContainer, style.rowReverse, style.bathM7TempContainer)}>
          <div className={style.bathText}>
            <span>MF7 Bath Temp</span> <span>M7 Roof Temp</span>
          </div>
          <div className={style.bathIcon}>
            <span>MF7</span>
            <UnitIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FourthRow;
